import { render } from "./ModalHistoricGrupoDetail.vue?vue&type=template&id=b5276902&ts=true"
import script from "./ModalHistoricGrupoDetail.vue?vue&type=script&lang=ts"
export * from "./ModalHistoricGrupoDetail.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Projects\\anc-transparencia\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__